import { useTranslation } from 'react-i18next';
import { OrderDocument } from '@/components/OrderDocument';
import { POrderDocument } from '../OrderDetailsPage';

export interface OrderDocumentsProps {
  documents: POrderDocument[];
  className?: string;
}

export default function OrderDocuments(props: OrderDocumentsProps) {
  const { documents, className = '' } = props;

  // const documents = [
  //   {
  //     url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  //     type: 'Invoice',
  //     id: '1',
  //   },
  //   {
  //     url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  //     type: 'Invoice',
  //     id: '2',
  //   },
  // ];

  const { t } = useTranslation();

  return (
    <div className={className}>
      <p className="font-bd mb-1-0">{t('orders.documents.title')}</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-1-6">
        {documents.map((document) => (
          <OrderDocument key={document.id} document={document} />
        ))}
        {documents.length === 0 && (
          <p className="text-1-2">{t('orders.documents_not_found')}</p>
        )}
      </div>
    </div>
  );
}
